module.exports = __webpack_public_path__ + "img/Blog.bd70f3f9.png";